<template>
  <div class="class-tree">
    <el-tree
      ref="tree"
      node-key="CID"
      :expand-on-click-node="false"
      :highlight-current="true"
      :data="treeData"
      :props="treeProps"
      :default-expanded-keys="[option.CID]"
      :render-content="renderTreeContent"
      @current-change="handleNodeChange"
      v-show="treeLoadingState==1">
    </el-tree>
  </div>
</template>

<script>
import { ApiService, DataService } from '@/service';

import ClassIcon from '@/components/icon/class-icon.vue';

export default {
  props: {
    option: {
      default: () => ({ CID: '1', type: 'prodcurrency', Icon: 'icon-spare-parts'})
    }
  },
  components: { ClassIcon },
  data() {
    return {
      treeProps: {//分类树参数
        children: 'children',
        label: "CName",
        isLeaf: "isLeaf"
      },
      treeData: [],//分类树的数据
      treeLoadingState: 0,//0 未加载  -1 加载中  1加载完成
      filter: {//列表区域加载数据需要的参数
        cid: '-2',
        resultType: 99,
        rootCid: "0",
        q: ""
      },
    }
  },
  mounted() {
    this.getClassAllComposes();
  },
  methods: {
    getClassAllComposes() {//获取当前分类下的树的数据
      this.treeLoadingState = -1;
      let url = `${ApiService.JrzzApi}/api/Class/GetClassAllComposes`;
      DataService.post(url, [Number(this.option.CID)]).then(res => {
        this.treeLoadingState = 1;
        this.allTreeData = res;
        let root_node = this.allTreeData.find(item => item.CID == this.option.CID);
        root_node.CName = '供应商分类';
        if (!root_node) return;
        // this.$set(root_node, "icon", (this.props.Icon || ""));
        // this.$set(root_node, "treeKey", this.props.CID);
        this.treeData.push(root_node);
        this.treeData[0].children = this.packTreeData(root_node);
        // this.breadcrumbData = [root_node];
        // this.curTreeNodeChildren = root_node.children;
        //树可能还没有加载完成 延迟了200
        setTimeout(() => {
          this.setTreeCurrent(this.option.CID);
        }, 200)
        this.loadDataList();
      }).catch(e => {
        this.treeLoadingState = 1;
      })
    },
    setTreeCurrent(cid) {//这是当前分类树选中的节点
      this.$refs.tree.setCurrentKey(cid);
    },
    renderTreeContent(h, {node, data, store}) {//渲染分类树节点的诗句
      //TODO:使用了JSX IDE js语音设置需要配制成React JSX
      return (
        <span>{
          data.icon ?
            <i class={`iconfont ${data.icon}`}></i> :
            <ClassIcon class-id={data.CID} logo-height={16} logo-width={16}
                        style={{width: '16px', height: '16px'}}></ClassIcon>
        }
          &nbsp;{data.CName}
      </span>
      );
    },
    handleNodeChange(data, node, isBack) {//选中的节点发生了改变
      if (data.CID !== this.filter.cid) {
        this.filter.cid = data.CID;
        this.filter.classQ = data.CName;
        this.filter.treeKey= data.treeKey
        // this.loadDataList();
        this.$emit('cidChange', {cid:data.CID, CName: data.CName});
      }
    },
    packTreeData(parentNode) {
      let cn = [];
      this.allTreeData.map(node => {
        if (node.ParentID == parentNode.CID) {
          node.rendered = false;
          node.treeKey = `${parentNode.treeKey}|${node.CID}`
          node.children = this.packTreeData(node);
          cn.push(node);
        }
      })
      return cn;
    },
  },
}
</script>

<style lang="less" scoped>
  .class-tree{
    // width: 230px;
    height: calc(100vh - 20px - 43px);
    overflow: auto;
    /deep/ .el-tree-node__content{
      font-size: 14px;
      color: #606672;
    }
  }
</style>
